/**
 * @group Patient
 * @summary Barrel export for patient domain constants
 */

export { CONSULTATION_STATUS } from './CONSULTATION_STATUS';
export { PAYMENT_METHOD_TYPE } from './PAYMENT_METHOD_TYPE';
export { PAYMENT_METHOD_CHANNELS } from './PAYMENT_METHOD_CHANNELS';
export type { PaymentMethodChannel } from './PaymentMethodChannel';